import axios from "axios";

const dsdeURL = "/api/v1/dsdes";

const dsdeApi = {
  fetch: () => axios.get(dsdeURL),
  create: payload => axios.post(dsdeURL, { dsde: payload }),
  show: payload =>
    axios.post(`${dsdeURL}/get_dsde_by_cde_and_data_source`, { dsde: payload }),
  update: payload => axios.put(`${dsdeURL}/1`, { dsde: payload }),
  fetchReferenceSources: (id, page = 1, per = 1000, search = "") =>
    axios.get(
      `${dsdeURL}/${id}/reference_sources?page=${page}&per_page=${per}&search=${search}`
    ),
};

export default dsdeApi;
